import { GestureResponderEvent, Pressable, StyleProp, StyleSheet, Text, TextStyle, ViewStyle } from 'react-native'
import React from 'react'
import { colors } from '@lib/colors'

interface ButtonProps {
  label: string
  onPress?: (e: GestureResponderEvent) => void
  buttonStyles?: StyleProp<ViewStyle>
  disabledButtonStyles?: StyleProp<ViewStyle>
  textStyles?: StyleProp<TextStyle>
  disabledTextStyles?: StyleProp<TextStyle>
  disabled?: boolean
}

interface Styles {
  button: ViewStyle;
  buttonDisabled: ViewStyle;
  label: TextStyle;
  labelDisabled: TextStyle;
}

export default function ({
  label,
  onPress,
  disabled,
  buttonStyles = {},
  disabledButtonStyles,
  textStyles = {},
  disabledTextStyles,
}: ButtonProps) {
  if (disabled) {
    return (
      <Pressable style={
        StyleSheet.compose(styles.button, disabledButtonStyles || styles.buttonDisabled)
      } disabled>
        <Text style={
          StyleSheet.compose(styles.label, disabledTextStyles || styles.labelDisabled)}
        >{ label }</Text>
      </Pressable>
    )
  }

  return (
    <Pressable style={StyleSheet.compose(styles.button, buttonStyles)} onPress={onPress}>
      <Text style={StyleSheet.compose(styles.label, textStyles)}>{ label }</Text>
    </Pressable>
  )
}

const styles = StyleSheet.create<Styles>({
  button: {
    backgroundColor: colors.black,
    alignItems: 'center',
    padding: 15,
    borderRadius: 5,
  },
  label: {
    color: colors.white,
    fontSize: 16,
    fontWeight: 'bold',
  },
  buttonDisabled: {
    backgroundColor: colors.gray[200],
    fontWeight: 'bold',
  },
  labelDisabled: {
    color: colors.white,
    fontWeight: 'normal',
  },
})
